export default __webpack_public_path__ + "static/media/Wristwraps of Intricate Spite.c7699319.jpg";